import { Link } from 'react-router-dom';
import { KeycloakInstance } from 'keycloak-js';
import kebabCase from 'lodash.kebabcase';
import { AvatarHead } from '@amplify/avatar-builder';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { AuthService } from 'shared/lib/keycloak';
import { useAppDispatch } from 'shared/lib/redux';
import { eventService, getPage, XApiEventKeys } from 'shared/api/event-service';
import { Tooltip } from 'shared/ui/tooltip';

import { useAvatarConfigSelector, saveAvatar } from './model';
import { Illustration } from './illustration';
import styles from './styles.module.scss';
import './styles-overrides.scss';

export const Avatar = () => {
  const { t } = useTranslation();
  const kc = AuthService.getKC();

  const { avatarConfig } = useAvatarConfigSelector();

  const dispatch = useAppDispatch();

  const handleSaveAvatar = (characterAssets: null) =>
    dispatch(saveAvatar(characterAssets));

  const handleAvatarHeadContexMenu = () => {
    eventService.send(XApiEventKeys.openedAvatarBuilder, undefined, {
      result: {
        isRightClick: true,
        url: window.location.href,
        page: getPage(),
      },
    });
  };

  return (
    <Illustration>
      <Tooltip
        title={t('Edit your Avatar')}
        tooltipClassNames="avatar-tooltip"
        wrapperClassNames={clsx(styles.tooltipWrapper)}
        shouldAddAriaLabelledBy={false}
      >
        <div className={styles.avatar}>
          <Link
            to="avatar"
            className={styles.avatarLink}
            aria-label={`Go to avatar builder`}
            data-testid="avatar"
            onContextMenu={handleAvatarHeadContexMenu}
          >
            <AvatarHead
              isBig={true}
              assets={avatarConfig}
              onAvatarLoad={handleSaveAvatar}
              config={{
                kc: kc ?? ({} as KeycloakInstance),
                ampEvents: eventService.ampEvents,
                appName: 'educator-home',
              }}
              isTeacher={true}
              containerClassNames={styles.headContainer}
              avatarClassNames={styles.headAssets}
              xAPIEventsContextExtensions={{
                result: {
                  'application-version':
                    kebabCase(import.meta.env.VITE_APP_VERSION) || '0-1-0',
                },
              }}
            />
          </Link>
        </div>
      </Tooltip>
    </Illustration>
  );
};
